var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';













const EmbededButton = ({
  color = 'white',
  children,
  type = 'button',
  disabled,
  form,
  onClick,
  icon,
  collapsed,
  className = ''
}) => {
  let buttonColor = 'green';
  let childrenBaseStyle = 'text-sm font-medium';

  switch (color) {
    case 'orange':
      buttonColor = 'text-orange-600 bg-orange-50';
      break;
    case 'green':
      buttonColor =
      'text-green-400 bg-green-100 border-green-200 disabled:text-green-200 disabled:bg-green-50 disabled:border-green-200';
      break;
    case 'red':
      buttonColor = 'bg-gray-50';
      childrenBaseStyle = 'text-gray-300';
      break;
    case 'indigo':
      buttonColor =
      'text-indigo-700 bg-indigo-200 border-indigo-300 disabled:text-indigo-200 disabled:bg-indigo-50 disabled:border-indigo-200';
      break;
    case 'white':
      buttonColor = 'bg-white border-gray-200 disabled:text-gray-300 disabled:bg-gray-50';
      break;
    default:
      buttonColor = '';
  }

  if (collapsed) {
    childrenBaseStyle = 'sr-only';
  }

  return /*#__PURE__*/(
    _jsx("button", {
      type: type === 'submit' ? 'submit' : 'button',
      onClick: onClick,
      disabled: disabled,
      className: `${className} ${buttonColor} 
      ${collapsed || disabled ? '' : 'border'}
      ${collapsed || disabled ? 'px-[7px] py-[3px]' : 'px-1.5 py-0.5'}
      drop-shadow-md disabled:drop-shadow-none active:drop-shadow-none text-xs disabled:cursor-not-allowed font-medium rounded-[4px]
      focus:outline-none`,
      form: form }, void 0, /*#__PURE__*/

    _jsx("div", { className: "flex flex-row items-center justify-center gap-1" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "w-3 h-3 text-sm" }, void 0, icon), /*#__PURE__*/
    _jsx("div", { className: childrenBaseStyle }, void 0, children)
    )
    ));

};

export { EmbededButton };